import React, { forwardRef } from 'react'
import { useDitto } from '@ow/ditto-core'
import { RichEditor } from '@ow/comps'

const Render = function ({ opts = {}, onChange, formControl, value }, ref) {
  console.log(opts, onChange, value)
  const { slug } = opts
  const { setValue, getValues } = formControl || {}
  const { upload: onClickUpload, appId } = useDitto()

  const uploadImg = (file) => {
    const formData = new FormData()
    formData.append('files', file)
    formData.append('appId', appId)
    return onClickUpload(formData)
  }

  return (
    <div className="relative flex flex-row items-center" ref={ref}>
      <RichEditor
        onChange={(props) => {
          const { textVal, selfVal } = props

          if (onChange) {
            onChange(textVal)
          }
          if (setValue) {
            setValue(slug + '_slateRichText', selfVal)
          }
        }}
        uploadImg={uploadImg}
        value={getValues(slug + '_slateRichText')}
      />
    </div>
  )
}

export default forwardRef(Render)
